<template>
  <div v-if="dealers" class="Page">
    <section class="">
      <div class="banner">
        <h1 class="PageTitle" style="">Nous Joindre</h1>
      </div>
    </section>
    <section class="">
      <div class="orangeStripe"></div>
      <div style="height: 400px; position: relative;">
        <StoreLocator />
      </div>
    </section>
    <section style="height: 100%; position: relative;" class="">
      <v-row class="">
        <v-col cols="12" class="bgServiceGray"><h2 class="sectionTitle txt-c">NOS CONCESSIONNAIRES</h2></v-col>
        <v-row class="bgDealers">
          <v-col  v-for="(item,i) in dealers" :key="i" class="bgDealer">
            <!--
            <div class="card dealerFront">
              
              <v-row class="d-flex align-center textDealerFront" style="">
                <v-col cols="12">
                  <h2 class="town">{{ item.town }}</h2>
                  <p class="name">{{ item.name }}</p>
                </v-col>
              </v-row>
            </div>-->
            <div class="card dealerBack" >
              <img style="position: absolute; z-index: 10; height: 300px; width: 350px;" :src="item.img" :alt="'Concessionnaire ' + item.name + ' à ' + item.town + ' — Réseau Dynamique'" />
              <img class="imgDealerBack" style="" src="/ressources/images/contactUs/baseSquare.jpg" alt="Fond carte concessionnaire" />
              <v-row class="textDealerBack" style="">
                <v-col cols="12"><h2 class="titleDealerBack">{{ item.town }}</h2></v-col>
                <v-col cols="12 d-flex align-center" style="margin-top: 20px;">
                  <img class="icon" src="/ressources/images/icon/phone.png" alt="Icône téléphone" />
                  <a class="phoneText" :href="'tel:' + item.phone" style="" v-html="item.phone"></a>
                </v-col>
                <v-col cols="12 d-flex align-center" style="margin-top: 20px;">
                  <img class="icon" src="/ressources/images/icon/Courriel.png" alt="Icône courriel" />
                  <a :href="'mailto:' + item.email" class="emailText">{{ item.email }}</a>
                </v-col>
                <v-col cols="12 d-flex align-center">
                  <h2 style="color: rgb(var(--primary)); font-size: 48px; font-family: TxtOffRe; font-weight: 700;">></h2>
                  <router-link :to="item.path"><p class="fiche">Voir la fiche</p></router-link>
                </v-col>
              </v-row>
            </div> 
        </v-col>
        </v-row>
      </v-row>
      
    </section>

  </div>
</template>
<style scoped>
    .bgServiceGray { background-color: rgb(var(--gray)); padding: 50px 0px 50px 0px !important; }
    .PageTitle { position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); }
    .banner { position: relative; height: 400px; background-image: url('../../public/ressources/images/contactUs/BannerContactUs.jpg'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
    .bgDealer { position: relative; max-width: 350px; min-width: 350px; width: 250px; height: 300px; margin: 20px auto; perspective: 1000px;  }
    .bgDealers {padding: 50px 5%; background-color: rgb(var(--ligthGray));}
    .fiche { padding-left: 10px; display: inline-block; color: white; cursor: pointer; }
    .fiche:hover { color: rgb(var(--secondary)); }
    .town { font-family: TxtOffBDI; text-transform: uppercase; color: #FFFFFF; text-align: center; }
    .name { font-family: TxtOffRe; color: #FFFFFF; text-align: center; }
    .textDealerFront { position: relative; z-index: 100; padding: 40px; width: 100%; height: 100%; }
    .imgDealerBack { position: absolute; z-index: 10; height: 300px; width: 350px; opacity:0.7; }
    .textDealerBack { position: relative; z-index: 100; padding: 40px; width: 100%; }
    .titleDealerBack { font-family: TxtOffBDI; text-transform: uppercase; color: #FFFFFF; }
    .icon { display: inline-block; height: 35px; width: auto; }
    .phoneText {padding-left: 10px; display: inline-block; color: white;}
    .emailText { font-size: small;  padding-left: 10px; display: inline-block; color: rgb(var(--secondary)); cursor: pointer;}
    .card { width: 100%; height: 100%; position: relative; }

    @media handheld, only screen and (max-width: 960px) {
        h2 { font-size: 18px !important; }
        .bgDealers {padding: 0px; background-color: rgb(var(--ligthGray));}
    }
</style>
<script>
import StoreLocator from "../components/storeLocator.vue";
export default {
  name: 'ContactUs',
  data:()=>({
    dealers: null,
  }),
  mounted() {
    // Meta tags SEO
    document.title = 'Nous joindre | 22 concessionnaires camions International au Québec — Réseau Dynamique';
    this.setMeta('description', 'Trouvez le concessionnaire Réseau Dynamique le plus près de chez vous. 22 succursales au Québec : Anjou, Boucherville, Drummondville, Québec, Lévis, Sherbrooke, Trois-Rivières, Sept-Îles et plus. Camions International, Isuzu, Kalmar Ottawa.');
    this.setMeta('og:title', 'Nous joindre | Concessionnaires camions International — Réseau Dynamique');
    this.setMeta('og:description', '22 concessionnaires de camions International répartis à travers le Québec. Trouvez votre succursale la plus proche pour la vente, le service et les pièces.');
    this.setMeta('og:type', 'website');
    this.setMeta('og:url', 'https://reseaudynamique.com/nous-joindre');
    this.setMeta('og:image', 'https://reseaudynamique.com/ressources/images/contactUs/BannerContactUs.jpg');

    this.dataRead();
  },
  methods:{
    /** Helper pour ajouter/mettre à jour les balises meta */
    setMeta(name, content) {
      const isOg = name.startsWith('og:');
      const attr = isOg ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    },
    dataRead: async function () {
        try {
            const response = await fetch('/ressources/json/dealers.json');
            if (!response.ok) {
                throw new Error('Failed to fetch');
            }
            this.dealers = await response.json();
        } catch (error) {
            console.error('Error loading JSON data:', error);
        }
    },
  },
  components: { 
    StoreLocator
  }
}
</script>